import { render, staticRenderFns } from "./PhysicianNew.vue?vue&type=template&id=abc509ec&"
import script from "./PhysicianNew.vue?vue&type=script&lang=js&"
export * from "./PhysicianNew.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports